import { Component, Input } from '@angular/core';


@Component({
  moduleId: module.id,
  selector: 'empty-state',
  templateUrl: 'empty-state.component.html',
  styleUrls: ['empty-state.component.scss'],
})
export class EmptyStateComponent {
  @Input() text: string = '';
}
